import classNames from 'classnames';
import React from 'react';
import { TextLabel } from '../../DistributionComponents/Text';
import './SpinnerButton.css';
export const SpinnerButton = ({ href, text, textKey, secondary, isSpinning, ...props }) => {
  const getText = () => {
    if (typeof text === 'string') {
      return text;
    } else if (text && textKey) {
      return text[textKey].value;
    }
    return '';
  };
  const buttonType = secondary ? 'secondary' : 'primary';
  return (
    <div {...props} className={classNames('button spinner', { ['button--' + buttonType]: true })}>
      {!isSpinning ? (
        <a href={href}>
          <TextLabel className="md-regular" field={{ key: textKey, text: getText() }} />
        </a>
      ) : (
        <div className="lds-dual-ring"></div>
      )}
    </div>
  );
};
